import { Component, Input, OnInit } from '@angular/core';
import { CaseSession } from '../models/hearings/caseSession';
import { User, UserRole } from 'src/app/shared/models/users/user';
import { AuthService } from './../../core/services/auth/auth.service';

@Component({
  selector: 'app-case-hearing-row-details',
  templateUrl: './case-hearing-row-details.component.html',
  styleUrls: ['./case-hearing-row-details.component.scss']
})
export class CaseHearingRowDetailsComponent implements OnInit {
  @Input() caseSession: CaseSession;
  user: User;
  constructor(
    private auth: AuthService,
  ) {
    this.user = this.auth.user;

  }

  ngOnInit(): void {
  }

  get isAdmin() {
    return UserRole.ADMIN === this.user.role;
  }

}
